/**
 * Returns a value that will increment and decrement between the value 0 and length.
 *
 * @param value The value.
 * @param length The length.
 * @returns Returns a value that will move back and forth between 0 and length.
 * @example
 *
 * pingPong(1, 5)
 * // => 1
 *
 * pingPong(6, 5)
 * // => 4
 *
 * pingPong(10, 5)
 * // => 0
 */
export function pingPong(value: number, length: number): number {
  const max = 2 * length;
  const mod = value % max;
  return mod < length && mod >= 0 ? mod : max - mod;
}
